/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_CATEGORIES_MAIN(state, categories_main) {
    state.categories_main = categories_main
  },
  SET_CATEGORIES_THEMATIC(state, categories_thematic) {
    state.categories_thematic = categories_thematic
  },
  // REMOVE_RECORD(state, itemId) {
  //     const transactionIndex = state.transactions.findIndex((u) => u.id == itemId)
  //     state.transactions.splice(transactionIndex, 1)
  // },
}
